module.exports = __webpack_public_path__ + "static/img/5.a52dadd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/sp/5.png
// module id = jP6J
// module chunks = 0